// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { IPublicClientApplication, AccountInfo, InteractionRequiredAuthError } from '@azure/msal-browser';
import { funcAppRequest, loginRequest, teamsEndpointRequest } from '../authentication/authConfig';

const getAccessToken = async (
  instance: IPublicClientApplication,
  accounts: AccountInfo[],
  scopes: string[]
): Promise<string> => {
  let accessToken = '';
  if (accounts.length > 0) {
    const request = {
      scopes: scopes,
      account: accounts[0]
    };
    try {
      const response = await instance.acquireTokenSilent(request);
      accessToken = response.accessToken;
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        const response = await instance.acquireTokenPopup(request);
        accessToken = response.accessToken;
      }
    }
  }
  return accessToken;
};

export const authModule = {
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleLogin: async (instance: IPublicClientApplication): Promise<void> => {
    await instance.loginRedirect(loginRequest).catch((error: any) => {
      console.error(JSON.stringify(error));
    });
  },

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  handleLogout: async (instance: IPublicClientApplication): Promise<void> => {
    await instance.logoutRedirect().catch((error: any) => {
      console.error(JSON.stringify(error));
    });
  },

  getProfileAccessToken: async (instance: IPublicClientApplication, accounts: AccountInfo[]): Promise<string> => {
    return await getAccessToken(instance, accounts, loginRequest.scopes);
  },

  getAppAccessToken: async (instance: IPublicClientApplication, accounts: AccountInfo[]): Promise<string> => {
    return await getAccessToken(instance, accounts, funcAppRequest.scopes);
  },

  getTeamsEndpointToken: async (instance: IPublicClientApplication, accounts: AccountInfo[]): Promise<string> => {
    return await getAccessToken(instance, accounts, teamsEndpointRequest.scopes);
  }
};
